import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Center, Container, Group, Image, Text, Title } from '@mantine/core';

import { Button } from 'components';
import errorClasses from '../error.module.css';
import { AppConstants, RouteConstants } from '../../../constants';

const { LOGO_DARK } = AppConstants;
const { ROUTE_HOME } = RouteConstants;

const Error406Page = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Center h={'100vh'}>
      <Container>
        <Image
          src={LOGO_DARK}
          alt={'Webkredit.ch logo'}
          mx={'auto'}
          pb={'lg'}
          className={errorClasses.logo}
        />
        <Title className={errorClasses.title}>{t('error.406.title')}</Title>
        <Text size={'lg'} ta={'center'} className={errorClasses.description}>{t('error.406.description')}</Text>
        <Group justify={'center'}>
          <Button onClick={() => navigate(ROUTE_HOME)}>{t('action.homePage')}</Button>
        </Group>
      </Container>
    </Center>
  )
}

export default Error406Page;